import React from 'react';
import { ProductContainer, ProductDetails, ProductDiscount, ProductImage, ProductName, ProductPrice, ProductPriceContainer } from './style';
import Button from '../Miscellaneous/Button';
import { ShoppingCart, Eye } from 'lucide-react';
import OptimizedImage from '../OptimizedImage';

export default function Product(props) {
    const { product, variant } = props;
    const [imageError, setImageError] = React.useState(false);
    const [isHovered, setIsHovered] = React.useState(false);

    // Si es variante megamenu, usar diseño nuevo
    if (variant === 'megamenu') {
        return (
            <div
                onClick={() => {
                    window.location.href = `/details/${product.productURL}`;
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    width: '100%',
                    maxWidth: '220px',
                    backgroundColor: '#fff',
                    borderRadius: '0.75rem',
                    border: '1px solid #e5e7eb',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: isHovered ? '0 10px 25px -5px rgba(0, 0, 0, 0.1)' : '0 1px 3px rgba(0, 0, 0, 0.1)',
                    transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
                    position: 'relative'
                }}
            >
                {/* Imagen del producto */}
                <div
                    style={{
                        width: '100%',
                        height: '180px',
                        backgroundColor: '#f9fafb',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    <OptimizedImage
                        src={imageError ? 'https://cdn.beeapp.es/distribucionesrb/NoImage.png' : product.images[0]}
                        alt={product.name}
                        width={220}
                        height={180}
                        fit="contain"
                        quality={80}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            padding: '1rem',
                            transition: 'transform 0.3s ease',
                            transform: isHovered ? 'scale(1.05)' : 'scale(1)'
                        }}
                    />

                    {/* Badge de stock */}
                    {product.stock > 0 && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '0.5rem',
                                right: '0.5rem',
                                backgroundColor: '#028322',
                                color: '#fff',
                                padding: '0.25rem 0.5rem',
                                borderRadius: '0.375rem',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.25rem'
                            }}
                        >
                            En stock
                        </div>
                    )}

                    {/* Overlay en hover */}
                    {isHovered && (
                        <div
                            style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                background: 'linear-gradient(to top, rgba(2, 131, 34, 0.9), transparent)',
                                padding: '2rem 1rem 0.75rem',
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '0.5rem',
                                animation: 'fadeIn 0.2s ease'
                            }}
                        >
                            <button
                                style={{
                                    backgroundColor: '#fff',
                                    color: '#028322',
                                    border: 'none',
                                    borderRadius: '0.5rem',
                                    padding: '0.5rem',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '40px',
                                    height: '40px',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#028322';
                                    e.currentTarget.style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#fff';
                                    e.currentTarget.style.color = '#028322';
                                }}
                            >
                                <Eye size={20} strokeWidth={2.5} />
                            </button>
                        </div>
                    )}
                </div>

                {/* Detalles del producto */}
                <div
                    style={{
                        padding: '1rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem'
                    }}
                >
                    {/* Nombre */}
                    <h4
                        style={{
                            margin: 0,
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            color: '#1f2937',
                            lineHeight: '1.25rem',
                            height: '2.5rem',
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical'
                        }}
                    >
                        {product.name}
                    </h4>

                    {/* Precio */}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'baseline',
                            gap: '0.5rem'
                        }}
                    >
                        <span
                            style={{
                                fontSize: '1.25rem',
                                fontWeight: 700,
                                color: '#028322'
                            }}
                        >
                            {product.price ? product.price.toString().replace('.', ',') + '€' : 'Inicia Sesión'}
                        </span>
                        {product.oldPrice && (
                            <span
                                style={{
                                    fontSize: '0.875rem',
                                    fontWeight: 500,
                                    color: '#9ca3af',
                                    textDecoration: 'line-through'
                                }}
                            >
                                {product.oldPrice.toString().replace('.', ',')}€
                            </span>
                        )}
                    </div>

                    {/* Botón Ver Producto */}
                    <button
                        style={{
                            width: '100%',
                            backgroundColor: isHovered ? '#028322' : '#f0fdf4',
                            color: isHovered ? '#fff' : '#028322',
                            border: '1px solid ' + (isHovered ? '#028322' : '#028322'),
                            borderRadius: '0.5rem',
                            padding: '0.5rem 1rem',
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            marginTop: '0.25rem'
                        }}
                    >
                        <Eye size={16} strokeWidth={2.5} />
                        Ver Producto
                    </button>
                </div>
            </div>
        );
    }

    // Diseño original para otras vistas
    let size = 1;
    switch (props.size || 'S') {
        case 'S':
            size = 1;
            break;
        case 'M':
            size = 1.25;
            break;
        case 'L':
            size = 1.5;
            break;
        case 'XL':
            size = 1.75;
            break;
        default:
            size = 1;
            break;
    }

    return (
        <ProductContainer
            size={size}
            onClick={() => {
                window.location.href = `/details/${product.productURL}`;
            }}
        >
            <ProductImage imageUrl={product.images[0]}/>
            <ProductDetails>
                <ProductName>{product.name}</ProductName>
                <ProductPriceContainer>
                    <ProductPrice>{product.price ? product.price.toString().replace('.',',')+'€' : 'Inicia Sesión'}</ProductPrice>
                </ProductPriceContainer>
                <Button
                    size="S"
                >
                    Ver Producto
                </Button>
            </ProductDetails>
        </ProductContainer>
    )
}